import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Service from '../../../../util/Service';
import { Alert, Box, ButtonGroup, FormControlLabel, InputAdornment, List, ListItem, ListItemButton, ListItemText, Popover, Snackbar, Stack, Switch, TextField } from '@mui/material';
import { Add, ArrowBack, ArrowDropDown, ArrowDropUp, Check, Delete, Edit, MoreVert, NavigateBefore, SystemUpdate, Visibility } from '@mui/icons-material';
import GaleriaComp from '../../../util/GaleriaComp';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function SlideShowDialog(props) {
    const {
        open, setOpen, onSelect, code, clonedContent, closePai, refDiv, refreshEditor,
        paginas, setPaginas, element
    } = props;

    const [valor, setValor] = React.useState('');
    const [titulo, setTitulo] = React.useState('');
    const [tipo, setTipo] = React.useState();
    const [nomeArquivo, setNomeArquivo] = React.useState();
    const [tipoAnexo, setTipoAnexo] = React.useState();
    const [erroTipo, setErroTipo] = React.useState('');
    const [descricaoAnexo, setDescricaoAnexo] = React.useState();


    const [valorEdit, setValorEdit] = React.useState('');
    const [lst, setLst] = React.useState([]);
    const [isEdit, setIsEdit] = React.useState(false);
    const ref = React.useRef(null);
    const [openSnack, setOpenSnack] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [largura, setLargura] = React.useState();
    const [altura, setAltura] = React.useState();

    const [update, setUpdate] = React.useState(false);

    const [anchorEl, setAnchorEl] = React.useState(null);

    React.useEffect(() => {
        if (open) {
            if( element ){
                // console.log( clonedContent );
                const container = element.querySelector(".slideshow-container");
                // console.log( container);
                const h = container.style.height;
                const w =container.style.width;
                if( h)setAltura(h)
                if( w)setLargura (w)
                const mySlides = container.querySelectorAll(".mySlides");
                // console.log( mySlides );
                const arr= [];
                for( const el of mySlides){
                    console.log( el);
                    const txt = el.getAttribute("data-text");
                    const input = el.querySelector("input");
                    const img = el.querySelector("img");
                    let link = "";
                    let tp = '';
                    console.log( input );
                    if( input){
                        link = input.value;                        
                        tp = 'pagina'
                        
                    }else if( img){
                        link = img.src;
                        if( link.indexOf("getAnexoById") >=0){
                            let pos =link.indexOf("/api")
                            link = link.substring(pos, link.length);
                            tp = 'galeria';
                        }else{
                            tp = 'link'
                        }
                    }
                    console.log(arr, ">>>", txt)
                    arr.push({
                        link: link,
                        titulo: txt,
                        tipo: tp
                    })
                }
                setLst( arr);
                setUpdate(true)
            }else{
                setUpdate(false);
            }
        }
    }, [open])

    React.useEffect(() => {
        if (tipo === 'pagina') {
            buscaPaginasSeNecessario();
        }
    }, [tipo])

    const visibleRows = React.useMemo(
        () =>
            filtro(),
        //.sort(getComparator(order, orderBy)),
        // .sort((a, b) => {
        //     const lowerA = a.nome.toLowerCase();
        //     const lowerB = b.nome.toLowerCase();
        //     if (lowerA < lowerB) {
        //       return -1;
        //     }
        //     if (lowerA > lowerB) {
        //       return 1;
        //     }
        //     return 0;
        //   })
        [paginas],
    );

    const handleClickPovover = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClosePovover = () => {
        setAnchorEl(null);
    };
    const handlePaginaEscolha = (row) => {
        handleClosePovover();
        setValor(row.nome);
    }

    const openPopover = Boolean(anchorEl);
    const id = openPopover ? 'simple-popover' : undefined;

    const handleClose = () => {
        setOpen(false);
    };
    const handleCloseSnack = () => {
        setOpenSnack(false);
    }
    const buscaPaginasSeNecessario = () => {
        if (!paginas) {
            Service.GET("/api/security/paginaHtml/findAllRestrito").then(r => {
                setPaginas(r);
            })
        }
    }
    function filtro() {
        if (!paginas) return [];

        const arr = [...paginas].filter(p => p.tipo === 'pagina');

        return arr;
    }
    function formataData(sdt) {
        if (!sdt) return '';
        const dt = new Date(sdt);

        return dt.toLocaleDateString();
    }
    const montaSecondary = (row) => {
        let txt = "";
        if (row.titulo) {
            txt = row.titulo
        }
        txt += " - " + formataData(row.dtCriacao);
        return txt;
    }
    const criaFromGaleria = (img) => {
        console.log(img);
        setValor("/api/getAnexoById/" + img.id);
        setTitulo(img.nome);
        handleClosePovover();
    }
    function handleSalvarAnexo(e) {
        if (!tipoAnexo || tipoAnexo.length < 2) {
            setErroTipo('Indique o tipo para filtrar do upload');
            return;
        }
        const dado = {
            nome: nomeArquivo,
            tipo: tipoAnexo,
            descricao: descricaoAnexo
        }
        console.log(dado);
        Service.POST("/api/security/salvaAnexo", dado).then(r => {
            console.log(r);
            uploadArquivo(r)
        }).catch(e => {
            console.log("erro--->", e)
            alert(e);
        })
    }
    function uploadArquivo(ret) {
        let input = document.getElementById("file");
        const file = input.files;
        let dados = new FormData();
        dados.append('file', file[0]);

        Service.UPLOAD("/api/security/anexar/" + ret.id, dados).then(r => {
            const resp = JSON.parse(r)
            console.log( resp )
            if (resp.success) {
                setValor("/api/getAnexoById/" + resp.anexo.id);
                setTitulo(resp.anexo.nome);
                handleClosePovover();
            } 
            else {
                alert(resp.msg)
            }

        }).catch(e => {
            console.log("erro--->", e)
            alert(e);
        })
    }
    const addAnexo = () => {
        // setOpenUpload(true);
        let file = document.getElementById("file");
        file.click();
    }
    const showUpload=()=>{
        return (
            <List dense>
            <Stack direction="row" spacing={2} sx={{ border: '2px solid blue', p: 2 }}>
                <Stack spacing={2} sx={{ m: 1 }}>
                    <TextField label="Nome" variant="outlined" value={nomeArquivo} onChange={(e) => setNomeArquivo(e.target.value)} />
                    <TextField autoFocus
                        placeholder='Tipifique para faciliar futuras pesquisas'
                        label="Tipo" variant="outlined" value={tipoAnexo} onChange={(e) => { setTipoAnexo(e.target.value); setErroTipo(''); }}
                        error={erroTipo.length > 1}
                        helperText={erroTipo}
                    />
                    <TextField label="Descrição" variant="outlined" multiline rows={4} value={descricaoAnexo} onChange={(e) => setDescricaoAnexo(e.target.value)} />

                    <ButtonGroup variant="text" aria-label="Basic button group">
                        <Button onClick={() =>{
                            setTipo();
                            setValor("");
                        }}
                            startIcon={<NavigateBefore />}
                        >
                            Voltar
                        </Button>
                        <Button onClick={handleSalvarAnexo}>Salvar</Button>
                    </ButtonGroup>


                </Stack>
                <img
                    src="/enptyFile.png" alt="Imagem a ser enviada" id="file-preview" width="250" height="300"
                    onClick={addAnexo}
                />
            </Stack>
        </List>
        )
    }

    const montaTipo = () => {
        if (!tipo) {
            return (
                <ButtonGroup variant="text" aria-label="Basic button group">
                    <Button
                        onClick={() => {
                            setTipo("galeria");
                            setValor("");
                        }}
                    >
                        Galeria
                    </Button>
                    <Button
                        onClick={() => {
                            setTipo("upload");
                            setValor("");
                        }}
                    >Upload</Button>
                    <Button
                        onClick={() => {
                            setTipo('pagina');
                            setValor("");
                        }}
                    >
                        Pagina
                    </Button>
                    <Button onClick={() => {
                        setTipo('link');
                        setValor("http://");
                    }}>Link</Button>
                </ButtonGroup>
            )
        }
        if( tipo === 'upload'){
            return showUpload();
        }
        if (tipo === 'galeria') {
            return (
                <div>                    
                    <GaleriaComp onAction={criaFromGaleria} onClose={() => {
                        setTipo();
                        setValor("");
                    }} />
                </div>
            )
        }
        if (tipo === 'pagina') {
            return (
                <Stack direction="row" spacing={0}>
                    <div>
                        <IconButton size='small' color='primary' onClick={() => {
                            setTipo();
                            setValor("")
                        }}>
                            <ArrowBack />
                        </IconButton>
                    </div>
                    <List
                        sx={{
                            width: '100%',
                            maxWidth: 360,
                            minWidth: 120,
                            bgcolor: 'background.paper',
                            position: 'relative',
                            overflow: 'auto',
                            maxHeight: 300,
                            '& ul': { padding: 0 },
                        }}
                    >
                        {visibleRows && visibleRows.map((row, id) => (
                            <ListItem
                                key={`pg-${id}`}
                                sx={{ p: 0 }}
                            >
                                <ListItemButton onClick={() => handlePaginaEscolha(row)}>
                                    <ListItemText primary={row.nome} secondary={montaSecondary(row)} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Stack>
            )
        }
        if (tipo === 'link') {
            return (
                <Stack direction="row" spacing={1}>
                    <IconButton color='primary' onClick={() => {
                        setTipo();
                        setValor("")
                    }}>
                        <ArrowBack />
                    </IconButton>

                    <TextField id="outlined-basic" label="Informe conteudo" variant="standard"
                        helperText="Link para uma imagem externa"
                        value={valor} onChange={(e) => {
                            setValor(e.target.value);
                        }}
                        inputRef={ref}
                        sx={{ width: '300px' }}
                    />
                    <IconButton color='primary' onClick={handleClosePovover}>
                        <Check />
                    </IconButton>
                </Stack>
            )
        }
        return (<p>????</p>);
    }
    const handleUpdateCodigo=()=>{
        console.log('>>>não implementado<<<');

        const html = refDiv.current.innerHTML;
        // console.log( refDiv.current.innerHTML );
        const dado = {
            code: html,
            links: lst
        }
        console.log((typeof largura === 'number'));

        if (largura) dado.largura = isNaN(largura) ? largura : largura + "px";
        if (altura) dado.altura = isNaN(altura) ? altura : altura + "px";

        console.log( dado );
        
        Service.POST("/api/security/model/alteraSlideShow", dado).then(r => {
            console.log(r);
            if (r.success) {
                refDiv.current.innerHTML = r.dado;

                handleClose();
                closePai();
                refreshEditor("slideshow");
            } else {
                alert(r.msg)
            }
        })
    }
    const handleGerarCodigo = () => {
        if (!lst || lst.length === 0) {
            setMsg('Nenhum slide informado, indique ao menos um slide');
            setOpenSnack(true);
            return;
        }
        const remove = document.createElement('p');
        remove.setAttribute("id", "paraRemover");
        remove.textContent = "---";
        clonedContent.replaceWith(remove);

        const el = document.getElementById("very2Editor");
        const html = el?.innerHTML


        const dado = {
            code: html,
            links: lst
        }
        console.log((typeof largura === 'number'));

        if (largura) dado.largura = isNaN(largura) ? largura : largura + "px";
        if (altura) dado.altura = isNaN(altura) ? altura : altura + "px";

        Service.POST("/api/security/model/geraSlideShow", dado).then(r => {
            console.log(r);
            if (r.success) {
                refDiv.current.innerHTML = r.dado;

                handleClose();
                closePai();
                refreshEditor("slideshow");
            } else {
                alert(r.msg)
            }
        })
    }
    const getTipo = () => {
        if (tipo) return tipo;
        else {
            if (valor.toLocaleLowerCase().indexOf("http") >= 0) {
                return 'link'
            } else {
                return 'pagina';
            }
        }
    }
    const handleAddItem = () => {
        const arr = [...lst];
        arr.push({
            link: valor,
            titulo: titulo,
            tipo: getTipo()
        });
        setLst(arr)
        setValor('');
        setTitulo('');
        setTimeout(() => {
            ref.current.focus();
        }, 300);
    }
    const handleUpdateItem = () => {
        const arr = [...lst];
        let i = 0;
        for (i = 0; i < arr.length; i++) {
            if (arr[i].link === valorEdit) break;
        }
        const v = arr.splice(i, 1); // Remove the item and store it
        console.log( v );
        arr.splice(i, 0, {
            link: valor,
            titulo: titulo,
            tipo: tipo?tipo: v[0].tipo,
        });
        setValor('');
        setTitulo('');
        setLst(arr);
        setIsEdit(false)
    }
    const Remove = (item) => {
        const arr = [...lst];
        let i = 0;
        for (i = 0; i < arr.length; i++) {
            if (arr[i].link === item) break;
        }
        arr.splice(i, 1); // Remove the item and store it

        setLst(arr);
    }
    const handleKeyDown = (e) => {
        const keyName = e.key;

        if (keyName === "Enter") {
            if (!isEdit) handleAddItem();
            if (isEdit) handleUpdateItem();
        }
    }
    const moveUp = (item) => {
        const arr = [...lst];
        let i = 0;
        for (i = 0; i < arr.length; i++) {
            if (arr[i].link === item) break;
        }
        // const [item] = arr.splice(fromIndex, 1); // Remove the item and store it
        const [target] = arr.splice(i, 1); // Remove the item and store it

        arr.splice(i - 1, 0, target);
        setLst(arr)
    }
    const moveDown = (item) => {
        const arr = [...lst];
        let i = 0;
        for (i = 0; i < arr.length; i++) {
            if (arr[i].link === item) break;
        }
        // const [item] = arr.splice(fromIndex, 1); // Remove the item and store it
        const [target] = arr.splice(i, 1); // Remove the item and store it

        arr.splice(i + 1, 0, target);
        setLst(arr)
    }
    const edit = (item) => {
        console.log( item )
        setValor(item.link);
        setIsEdit(true);
        setValorEdit(item.link);
        setTitulo(item.titulo)

    }
    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Slide Show / Carousel
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <Typography gutterBottom>
                    Criação de componente de apresentação de Slide
                </Typography>
                <Typography gutterBottom>
                    Adicione um link para uma pagina ou para uma imagem.
                    Para definir uma pagina basta informar um nome de uma pagina já existente ou informar o nome e depois criar a pagina.
                </Typography>
                <Stack>
                    <Stack direction="row" spacing={2}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                            <Typography sx={{ verticalAlign: 'bottom' }}>Tamanho:</Typography>
                        </Box>
                        <TextField id="outlined-basic" label="Largura" variant="standard"
                            value={largura || ''} onChange={(e) => setLargura(e.target.value)}
                        />
                        <TextField id="outlined-basic" label="Altura" variant="standard"
                            value={altura || ''} onChange={(e) => setAltura(e.target.value)}
                        />
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <TextField id="outlined-basic" label="Informe conteudo" variant="standard"
                            helperText="Link para uma imagem ou pagina"
                            value={valor} onChange={(e) => setValor(e.target.value)}
                            onKeyDown={handleKeyDown}
                            inputRef={ref}
                            sx={{ width: '400px' }}
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                edge="end"
                                                color='primary'
                                                onClick={handleClickPovover}
                                            >
                                                <MoreVert />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                },
                            }}
                        />
                        <TextField id="outlined-basic" label="Informe Titulo" variant="standard"
                            helperText="Titulo da pagina ou link"
                            value={titulo} onChange={(e) => setTitulo(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                        {!isEdit && <Button size='small' endIcon={<Add />} onClick={handleAddItem}>
                            Add
                        </Button>}
                        {isEdit && <Button size='small' endIcon={<SystemUpdate />} onClick={handleUpdateItem}>
                            Atualiza
                        </Button>}

                    </Stack>
                    <List>
                        {lst && lst.map((row, id) => (
                            <ListItem
                                disablePadding key={"lst-" + id}
                                secondaryAction={
                                    <ButtonGroup edge="end" aria-label="delete">
                                        {id != 0 && <IconButton color="primary" onClick={() => moveUp(row.link)}>
                                            <ArrowDropUp />
                                        </IconButton>}
                                        {id != lst.length - 1 && <IconButton color="primary" onClick={() => moveDown(row.link)}>
                                            <ArrowDropDown />
                                        </IconButton>}
                                        <IconButton color="primary" onClick={() => edit(row)}>
                                            <Edit />
                                        </IconButton>
                                        <IconButton color="primary" onClick={() => Remove(row.link)}>
                                            <Delete />
                                        </IconButton>
                                    </ButtonGroup>
                                }
                            >
                                <ListItemButton>
                                    <ListItemText primary={row.link} secondary={row.titulo} />
                                </ListItemButton>
                            </ListItem>
                        ))}

                    </List>
                </Stack>
            </DialogContent>
            <DialogActions>
                {!update && 
                <Button autoFocus onClick={handleGerarCodigo}>
                    Gerar
                </Button>}
                {update && 
                <Button autoFocus onClick={handleUpdateCodigo}>
                    Alterar
                </Button>}
            </DialogActions>

            <Popover
                id={id}
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handleClosePovover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ display: 'flex', p: 1, alignItems: 'center', border: '1px solid black' }}>
                    <div>
                        {montaTipo()}
                    </div>
                </Box>
            </Popover>

            <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
                <Alert
                    onClose={handleCloseSnack}
                    severity="error"
                    variant="standard"
                    sx={{ width: '100%' }}
                >
                    {msg}
                </Alert>
            </Snackbar>
        </BootstrapDialog >

    );
}
